import { PATH_ROUTES } from "../router/routes";

export type PreguntaId = "p1" | "p2" | "p3" | "p4" | "p5";

export const PATH_TO_PREGUNTA_ID: Record<string, PreguntaId> = {
  [PATH_ROUTES.titulacions]: "p1",
  [PATH_ROUTES.professionsRegulades]: "p2",
  [PATH_ROUTES.professionalsSanitaris]: "p3",
  [PATH_ROUTES.desajustLaboralTitulacio]: "p4",
  [PATH_ROUTES.ofertaUniversitariaOcupacio]: "p5",
};

export const getPreguntaIdFromPath = (path: string): PreguntaId | null =>
  PATH_TO_PREGUNTA_ID[path] ?? null;
